<template>
	<div>
		<v-row>
			<v-col>
				<v-card color="green" dark>
					<v-card-title class="mt-4">
						<span class="pt-5" style="font-size: 2.5rem; font-weight: 200">Welcome, {{userInfo.firstName}}.</span>
					</v-card-title>				
					<v-card-text>	
						<p style="font-size: 1.5em; font-weight: 300">Any scheduled appointments are shown below. Questions? You can reach out to the project manager by email.</p>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn text dark :href="'mailto:henrikmoeller@m.works'" target="_blank">Email my Meisterworks contact</v-btn>
					</v-card-actions>
				</v-card>
			
			</v-col>
		</v-row>
		<v-row>
			<v-col v-if="appointments.length">
				<v-subheader class="ml-0 mb-2 mt-4">Upcoming Appointments</v-subheader>
				<p class="text-large">Video appointments will become available 10 minutes before the scheduled appointment time. To join an appointment, simply click on "Start Meeting" below.</p>
				<ParticipantAppointmentTile v-for="appointment in appointments" :key="appointment.id" :appointment="appointment" v-on:saved="saved = true"></ParticipantAppointmentTile>
			</v-col>
		</v-row>
		<v-snackbar v-model="saved">
		Saved
		<v-btn color="green" text @click="saved = false">
		Close
		</v-btn>
		</v-snackbar>

	</div>
</template>

<script>

	import Vuex from 'vuex'
	import ParticipantAppointmentTile from "../components/singles/ParticipantAppointmentTile"

	export default{
		name: "Participant", 
		data: ( ) => {
			return {
				current: false,
				showAppointmentDialog: 0
			}
		},
		components:{
			ParticipantAppointmentTile: ParticipantAppointmentTile
		},
		computed: {
			...Vuex.mapState({
				view: state => state.auth.view,
				user: state => state.auth.user,
				userInfo: state => state[state.auth.view].user,
				appointments: function(state){
					let appointments = state[state.auth.view].appointments;
					let sortedArray  = appointments.sort((a,b) => a.dateTime.toDate() - b.dateTime.toDate() );
					return sortedArray;
				}
			}),
		},
		methods:{
		},
		watch: {
			view: function(nv){
				if( nv !== 'panelmember' ){
					this.$router.replace({ name: "home" });
				}
			},
			user: {
				immediate: true, 
				handler: function(nv, ov){
					if( !nv ){ return; }
					if( nv == ov ){ return; }
					this.$store.dispatch( 'fetchUser' );
					this.$store.dispatch( 'fetchAppointments' );
					
				}
			},

		}
	}
</script>